import { useTranslation } from "react-i18next";

const testimonials = [
  {
    quoteKey: "testimonials.quote1",
    author: "Sarah M.",
    location: "Denver, CO",
    projectKey: "testimonials.project1",
  },
  {
    quoteKey: "testimonials.quote2",
    author: "Michael & Jane T.",
    location: "Portland, OR",
    projectKey: "testimonials.project2",
  },
  {
    quoteKey: "testimonials.quote3",
    author: "David L.",
    location: "Nashville, TN",
    projectKey: "testimonials.project3",
  },
];

const Testimonials = () => {
  const { t } = useTranslation();

  return (
    <section className="py-section-lg bg-background">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <p className="text-label text-muted-foreground mb-4">{t('testimonials.label')}</p>
          <h2 className="text-display-md font-serif text-foreground">
            {t('testimonials.headline')}
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.author}
              className="relative"
            >
              {/* Quote Mark */}
              <span className="text-8xl font-serif text-secondary absolute -top-6 -left-2 select-none">
                "
              </span>

              {/* Content */}
              <div className="relative pt-8">
                <p className="text-body text-foreground text-lg mb-8 leading-relaxed">
                  {t(testimonial.quoteKey)}
                </p>

                <div className="pt-6 border-t border-border">
                  <p className="font-medium text-foreground">{testimonial.author}</p>
                  <p className="text-sm text-muted-foreground mt-1">{testimonial.location}</p>
                  <p className="text-label text-muted-foreground mt-2">{t(testimonial.projectKey)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
